import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['nav']

  connect() {
    if (!this.hasNavTarget) return;

    this.sections = [...this.element.getElementsByTagName('section')];
    this.anchors = [...this.element.getElementsByClassName('section-anchor')];

    this.anchors.forEach(anchor => {
      var link = document.createElement('a');

      link.href = "#" + anchor.id;
      link.setAttribute('data-section', anchor.closest('section').id);

      this.navTarget.appendChild(link);
    });

    let navTarget = this.navTarget;

    function onChange(changes, observer) {
      changes.forEach(section => {
          if (section.intersectionRatio > 0 && section.isIntersecting) {
            let link = navTarget.querySelector('[data-section="' + section.target.id + '"]')
            if (link) {
              navTarget.querySelectorAll('a').forEach(a => {
                a.classList.remove('active');
              });

              link.classList.add('active');
            }
          }
      });
    }

    this.observer = new IntersectionObserver(onChange, {
      root: null,
      rootMargin: "0px",
      threshold: 0.75
    });

    this.sections.forEach(section => this.observer.observe(section));
  }
}